import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from './components/ui/sonner';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CallBar from './components/CallBar';
import Home from './pages/Home';
import About from './pages/About';
import MoldInspection from './pages/MoldInspection';
import AirQuality from './pages/AirQuality';
import ServiceAreas from './pages/ServiceAreas';
import CityPage from './pages/CityPage';
import Contact from './pages/Contact';
import Admin from './pages/Admin';
import NotFound from './pages/NotFound';

function Layout() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  if (isAdmin) {
    return (
      <Routes>
        <Route path="/admin" element={<Admin />} />
      </Routes>
    );
  }

  return (
    <>
      <Navbar />
      <main className="pt-[104px]">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/mold-inspection" element={<MoldInspection />} />
          <Route path="/air-quality" element={<AirQuality />} />
          <Route path="/service-areas" element={<ServiceAreas />} />
          <Route path="/service-areas/:city" element={<CityPage />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <div className="lg:hidden h-[76px]" aria-hidden="true" />
      <CallBar />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <Layout />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
